// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IInvitationStatusEnumDto } from './invitation-status-enum-dto.g';

export const invitationPublicDto = {
    domain_Name: 'domain_Name',
    email: 'email',
    status: 'status',
    isExpired: 'isExpired',
    hasAccount: 'hasAccount',
} as const;

export type TInvitationPublicDto = (typeof invitationPublicDto)[keyof typeof invitationPublicDto];

export interface IInvitationPublicDto {
    [invitationPublicDto.domain_Name]: string | null;
    [invitationPublicDto.email]: string | null;
    [invitationPublicDto.status]: IInvitationStatusEnumDto | null;
    [invitationPublicDto.isExpired]: boolean | null;
    [invitationPublicDto.hasAccount]: boolean | null;
}

export class InvitationPublicDto
    implements IInvitationPublicDto
{
    [invitationPublicDto.domain_Name]: string | null = null;
    [invitationPublicDto.email]: string | null = null;
    [invitationPublicDto.status]: IInvitationStatusEnumDto | null = null;
    [invitationPublicDto.isExpired]: boolean | null = null;
    [invitationPublicDto.hasAccount]: boolean | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IInvitationPublicData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[invitationPublicDto.guid] = modelData[invitationpublicData.guid];
    }

    static create(modelData?: any | null): IInvitationPublicDto | null {
        return modelData ? new InvitationPublicDto(modelData) : null;
    }
}
